import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, MenuItem, TextField} from '@material-ui/core'
import {connect} from 'react-redux'
import {dataActions} from '../../../../../actions'
import useForm from '../../../../../components/useForm'

const useStyles = makeStyles(theme => ({
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
    },
    swiperbuttonBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 120,
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    swiperButton: {
        boxShadow: 'none',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
        '&:focus': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
    },
    searchBox: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        borderRadius: theme.shape.borderRadius,
        margin: '0 0 0 5px',
        height: '40px',
    },
    input: {
        '&::placeholder': {
            fontSize: '0.70rem',
        },
    },
}))

const findValue = (formValues, value) => {
    for (let key in formValues) {
        if (
            Object.prototype.hasOwnProperty.call(formValues, key) &&
            formValues[key] === value
        ) {
            return key
        }
    }
    return null
}

const EditDepartmentUser = props => {
    const classes = useStyles()
    const {
        token,
        user,
        department,
        updateDepartmentUsers,
        handleCloseDialog,
    } = props

    const initFormValues = {
        departmentrole: user.role || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        euid: user.euid || '',
    }

    const {values, isChanged, handleChange, handleSubmit} = useForm(
        submitedituser,
        initFormValues
    )

    let payload = {
        department,
        values,
        user,
    }

    function submitedituser() {
        updateDepartmentUsers(token, payload)
        handleCloseDialog()
    }

    const formValid = {
        departmentrole: values.departmentrole ? true : false,
    }
    const disableSubmit =
        findValue(formValid, false) && isChanged ? true : false

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box className={classes.boundaryBox}>
                    <TextField
                        id="firstName"
                        name="firstName"
                        label="First Name"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={true}
                        value={values.firstName || ''}
                        onChange={handleChange}
                    />

                    <TextField
                        id="lastName"
                        name="lastName"
                        label="Last Name"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        value={values.lastName || ''}
                        disabled={true}
                        onChange={handleChange}
                    />

                    <TextField
                        id="euid"
                        name="euid"
                        label="EUID"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        disabled={true}
                        value={values.euid || ''}
                        onChange={handleChange}
                    />

                    <TextField
                        id="departmentrole"
                        name="departmentrole"
                        label="Role"
                        select
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        required
                        value={values.departmentrole || ''}
                        onChange={handleChange}
                    >
                        <MenuItem value={'admin'}>Administrator</MenuItem>
                        <MenuItem value={'creator'}>Creator</MenuItem>
                    </TextField>
                </Box>
                <Box className={classes.boundaryBox}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={disableSubmit}
                        className={classes.submitButton}
                    >
                        Update User
                    </Button>
                </Box>
            </form>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        department: state.departmentsdata.manageroledept,
        departmentusers: state.departmentusersdata.departmentuserslist,
    }
}

const mapDispatchToProps = {
    updateDepartmentUsers: (token, payload) =>
        dataActions.departmentusersUpdateRequest(token, payload),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDepartmentUser)
